/**
 * The external dependencies.
 */
import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
/**
 * The internal dependencies.
 */
import {
    errorDeselect,
    errorRecievedInstructions,
    errorSelect,
    qualityRecieveTasks,
    storeErrorDetails,
    storeErrorTask,
} from './actions';
import {storeTask, tasksDeselect, tasksRecievedInstructions} from "../tasks/actions";
import * as R from "ramda";

const errorreports = handleActions({
    [qualityRecieveTasks]: (state, {payload: {errortracking}}) => {
        return errortracking;
    },
}, []);

const current = handleActions({
    [errorSelect]: (state, {payload: {error}}) => error,
    [errorDeselect]: (state, {payload}) => {
        return {};
    },
}, {});

const currentInstructions = handleActions({
    [errorRecievedInstructions]: (state, {payload: {value}}) => {
        if (value['_embedded']){
            return R.defaultTo([], value['_embedded'].instruction);
        } else {
            return [];
        }
    },
    [errorDeselect]: (state, {payload}) => {
        return [];
    },
}, []);

const errorDetails = handleActions({
    [storeErrorDetails]: (state, {payload: {details}}) => {
        return details;
    },
    [errorDeselect]: (state, payload) => {
        return {};
    },
}, {});

export default combineReducers({
    errorreports,
    current,
    errorDetails,
    currentInstructions,
});



// WEBPACK FOOTER //
// ./src/store/quality/reducer.js